import { Badge, Card, Layout, Page, Text } from '@shopify/polaris'

import Avatar from '../components/Avatar'
import FormattedDateTime from '../components/FormattedDateTime'
import PermissionBadge from '../components/PermissionBadge'
import { useAdminAuth } from '../providers/AdminAuthProvider'

export default function AdminProfilePage() {
  const { adminUser } = useAdminAuth()

  return (
    <Page title="Profile">
      <Layout>
        <Layout.Section>
          <Card>
            <div
              style={{
                display: 'flex',
                gap: 16,
                alignItems: 'center',
                padding: '16px',
              }}
            >
              <Avatar
                name={adminUser?.name || 'Unknown'}
                picture={adminUser?.picture || undefined}
                size="xl"
              />

              <div style={{ flex: 1 }}>
                <Text as="p" variant="headingMd">
                  {adminUser?.name || 'Unknown'}
                </Text>
                <Text as="p" tone="subdued">
                  {adminUser?.id || 'No email available'}
                </Text>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: 8,
                  }}
                >
                  <div>
                    <Text as="p">
                      <Badge
                        tone={
                          adminUser?.status === 'active'
                            ? 'success'
                            : 'critical'
                        }
                      >
                        {(adminUser?.status || 'unknown').toString()}
                      </Badge>
                    </Text>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{ borderTop: '1px solid #e7e9eb', padding: '12px 16px' }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <Text as="p" tone="subdued">
                  <strong>Account Created:</strong>{' '}
                  <FormattedDateTime
                    date={adminUser?.created_at}
                    fallback="Not available"
                  />
                </Text>

                <Text as="p" tone="subdued">
                  <strong>Last Updated:</strong>{' '}
                  <FormattedDateTime
                    date={adminUser?.updated_at}
                    fallback="Not available"
                  />
                </Text>
              </div>
            </div>
          </Card>
        </Layout.Section>

        <Layout.Section>
          <Card>
            <div style={{ padding: 16 }}>
              <Text as="h3" variant="headingMd">
                Your Permissions
              </Text>
            </div>

            <div
              style={{ borderTop: '1px solid #e7e9eb', padding: '12px 16px' }}
            >
              <div
                style={{
                  marginTop: '8px',
                  display: 'flex',
                  gap: '8px',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                }}
              >
                {(adminUser?.permissions ?? []).length > 0 ? (
                  (adminUser!.permissions || [])
                    .slice()
                    .sort()
                    .map(permission => (
                      <PermissionBadge
                        key={permission}
                        permission={permission}
                      />
                    ))
                ) : (
                  <Text as="p" tone="subdued">
                    No permissions assigned
                  </Text>
                )}
              </div>
            </div>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  )
}
